import { Outlet } from "react-router-dom";

export default function QC() {
  return <Outlet />;
}
